<div id="header">
  <a class="logo" [routerLink]="homePageRoute">
    <img *ngIf="authService.isAuthenticated()" alt="Logo" src="assets/img/logo/{{ authService.organization.logo }}" />
    <img *ngIf="!authService.isAuthenticated()" alt="Logo" src="assets/img/logo/{{ environmentService.logo }}" />
  </a>

  <div class="section main-text">
    <div class="heading" [title]="headerService.centerContentText | async">
      {{ headerService.centerContentText | async }}
    </div>
    <div *ngIf="memberId" class="subheading">Pronouns: {{ headerService.pronounText | async }}</div>
  </div>

  <div
    *ngIf="authService.isAuthenticatedAndAgreed() && authService.linkedOrganizations?.length"
    class="section select-org"
  >
    <div ngbDropdown class="dropdown">
      <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" ngbDropdownToggle>
        <i class="far fa-building me-2"></i>
        <span class="me-1">{{ authService.organization.orgName }}</span>
      </button>
      <div class="dropdown-menu" ngbDropdownMenu>
        <button
          type="button"
          *ngFor="let organization of authService.linkedOrganizations"
          (click)="switchOrganization(organization)"
          class="dropdown-item btn-sm"
          ngbDropdownItem
        >
          {{ organization.orgName }}
        </button>
      </div>
    </div>
  </div>

  <div
    class="section messenger"
    *ngIf="authService.isAuthenticatedAndAgreed() && authService.isEntitled('/header/composeMessage.html')"
  >
    <button type="button" class="btn btn-outline-primary btn-sm circular" (click)="sendNewMessage(sendMessage)">
      <i class="fas fa-paper-plane fa-fw" aria-hidden="true"></i>
    </button>
  </div>

  <div class="section support" *ngIf="!authService.isAuthenticated()">
    <button type="button" class="btn btn-outline-primary btn-sm circular" [ngbPopover]="supportPopover">
      <i class="fas fa-question fa-fw" aria-hidden="true"></i>
    </button>

    <ng-template #supportPopover>
      <div [innerHTML]="supportInformation"></div>
    </ng-template>
  </div>

  <form
    class="section quick-search"
    *ngIf="authService.isAuthenticatedAndAgreed() && authService.isEntitled('/patients/viewPatients.html')"
  >
    <input
      id="header-quick-search"
      type="text"
      class="form-control"
      [class.quick-search-results]="!showingRecentlyViewed"
      [class.quick-search-recently-viewed]="showingRecentlyViewed"
      [class.loading]="searchingMemberList || searching"
      placeholder="Enter member ID or name"
      name="quickSearch"
      [(ngModel)]="searchValue"
      [ngbTypeahead]="searchMemberList"
      (keyup.enter)="fetchMemberId()"
      [inputFormatter]="formatSearchInput"
      (selectItem)="onSelectMember($event)"
      [resultTemplate]="searchResultTemplate"
      (focus)="searchInputFocus$.next($event.target.value)"
    />

    <ng-template #searchResultTemplate let-r="result" let-t="term">
      <ngb-highlight [result]="formatMemberQuickSearch(r)" [term]="t"></ngb-highlight>
    </ng-template>
  </form>
</div>

<ng-template #sendMessage let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Care Messenger</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <th-create-new-message></th-create-new-message>
  </div>
</ng-template>
